import React from 'react';

import ContentMatrix from '@/components/content-matrix';
import PageHeaderMatrix from '@/components/page-header-matrix';
import Layout from '@/components/layout';
import { CACHE, PAGE_SLUGS, SECTION_HANDLES } from '@/constants';
import { buildContentMatrixQuery, fetch } from '@/utils/api';
import { transformContentMatrix } from '@/utils/transform';
import { withAppProps, withAppProviders } from '@/utils/withAppProps';

const pageTitle = 'Contact Us';
const breadcrumbs = {
  title: pageTitle,
  ancestors: [{ title: 'Search', url: '/' }],
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'contentMatrices' implicitly has an 'any' type.
const ContactUs = ({ contentMatrices }) => {
  let { contentMatrix, pageHeaderMatrix } = contentMatrices[0];
  contentMatrix = transformContentMatrix(contentMatrix);
  pageHeaderMatrix = transformContentMatrix(pageHeaderMatrix);

  return (
    <Layout>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'elementMapping' is missing in type '{ blocks: any; breadcrumbs: { title: string; ancestors: { title: string; url: string; }[]; }; }' but required in type 'PageHeaderMatrixProps'. */}
      <PageHeaderMatrix blocks={pageHeaderMatrix} breadcrumbs={breadcrumbs} />
      <ContentMatrix blocks={contentMatrix} />
    </Layout>
  );
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'preview' implicitly has an 'any' type.
const getStaticProps = withAppProps(async ({ preview, previewData }) => {
  const contentMatrixQuery = buildContentMatrixQuery({
    section: SECTION_HANDLES.CONTACT_US,
    slug: PAGE_SLUGS.CONTACT_US,
  });
  const contentMatrixResponse = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: contentMatrixQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );

  return {
    props: { contentMatrices: contentMatrixResponse.data.data.entries },
    revalidate: CACHE.REVALIDATE,
  };
});

export default withAppProviders(ContactUs);
export { getStaticProps };
